import { Navigate } from 'react-router-dom';
import { useAuth } from '../provider/AuthProvider';

function ProtectedRoute({ children }) {
    const { token } = useAuth();
    const isAuthenticated = !!token;

    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return children;
}

export default ProtectedRoute;

